export const AdminSystemPermissions = {
  authors: {
    getDataTable: '',
    edit: '31.2',
    delete: '31.3',
    add: '31.1',
    content: '27.26',
  },
  quizzes: {
    getDataTable: '',
    edit: '131.1',
    add: '131.0',
    publish: '131.2',
  },
  questions: {
    lookupsByQuizId: '132.5',
    add: '132.0',
    edit: '132.1',
    delete: '132.3',
    changePublishState: '132.2',
  },
  BusinessGroup: {
    getDataTable: '',
    edit: '88.2',
    add: '88.1',
  },
  narrators: {
    getDataTable: '',
    edit: '68.2',
    delete: '68.3',
    add: '68.1',
  },
  publishers: {
    getDataTable: '152.0',
    edit: '152.1',
    add: '152.1',
    setContentEntity: '152.1',
  },
  dailyContent: {
    addDate: '83.0',
    add: '83.1',
  },
  users: {},
  policies: {
    edit: '47.2',
    delete: '47.3',
    add: '47.1',
  },
  suggestContent: {},
  ratingRecords: {
    edit: '68.2',
    delete: '68.3',
    add: '49.4',
  },
  customerCare: {
    editUser: '',
    deleteUser: '',
  },
  faqs: {
    edit: '78.3',
    delete: '78.4',
    add: '78.1',
  },
  goals: {
    edit: '41.2',
    delete: '41.3',
    add: '41.1',
  },
  quote: {
    delete: '57.4',
    edit: '57.3',
  },
  reportProblem: {
    edit: '75.3',
    delete: '75.4',
    add: '75.2',
  },
  contactUs: {
    answer: '86.2',
  },
  promoCode: {
    add: '63.1',
    assignProductGroup: '63.3',
    edit: '63.5',
  },
  offerCodeGroup: {
    add: '65.1',
  },
  branches: {
    edit: '139.3',
  },
  saleUsers: {
    assignBranch: '139.2',
    assignPublisher: '139.2',
    assignPromoCodeAlias: '139.2',
    updateActivation: '139.13',
  },
  eventKeyMappings: {
    edit: '143.2',
    changePublishingState: '143.5',
  },
  promoCodeAliases: {
    add: '116.1',
    edit: '116.3',
    publication: '116.2',
  },
  products: {
    add: '4.1',
    edit: '4.2',
  },
  productGroups: {
    add: '62.1',
    edit: '62.12',
    setProducts: '62.13',
  },
  coordinationUsers: {
    add: '146.0',
    edit: '146.1',
  },
  coordinationVoiceOver: {
    add: '148.5',
    edit: '148.6',
    delete: '148.7',
  },
  coordinationContent: {
    add: '147.1',
    edit: '147.5',
    delete: '147.7',
    show: '147.4',
  },
  voiceActors: {
    getDataTable: '155.0',
    edit: '155.1',
    add: '155.1',
  },
};

export const SuperAdminSystemPermissions = {
  flows: {
    add: '101.0',
  },
  flowSelections: {
    add: '102.0',
  },
  collectionComponents: {
    add: '54.1',
    edit: '54.2',
    delete: '54.3',
    dynamicZone: '54.7,54.8',
  },
  collectionComponentTypes: {
    add: '55.1',
    edit: '',
    delete: '55.9',
    details: '55.3',
  },
  componentTypes: {
    add: '52.1',
    edit: '',
    delete: '52.11',
    details: '52.3',
  },
  components: {
    add: '51.1',
    edit: '51.2',
    delete: '51.3',
    setItemTemplate: '51.7',
    setSeeAllPage: '51.8',
  },
  contentEntities: {
    add: '27.1',
    edit: '27.2',
    delete: '27.3',
    quote: '57.1',
    authors: '31.4',
    plans: '27.19',
    unAssignAuthor: '31.5',
    unAsignCollection: '28.4',
    publish: '27.24',
    publishAll: '27.24',
    download: '94.5',
  },
  contentEntityTypes: {
    add: '36.1',
    edit: '36.2',
    // delete:'52.11',
    details: '36.3',
  },
  team: {
    add: '18.9',
    assignRole: '18.13',
    softDelete: '18.5',
    editUser: '18.24',
    block: '18.8',
  },
  role: {
    edit: '21.1',
    delete: '19.3',
    add: '19.1',
    rolePermission: '21.0',
  },
  systemConfigs: {
    edit: '144.1',
  },
  contentEntityTypeNavigations: {
    add: '103.0',
    edit: '103.1',
  },
  contentEntityLists: {
    add: '145.2',
    edit: '145.1',
    getItems: '145.3',
  },
};
